/**
 * Quantity units for products (`Product.quantityUnit`, matching phase 6).
 *
 * The values are the backend's canonical symbols (`apps/matching/units.py`);
 * it refuses anything else. Matching compares quantities in the buyer's unit
 * and reads a product's price as per this unit. Labels live in `domain:unit`.
 */
export const QUANTITY_UNITS = [
  { symbol: "unit", key: "unit" },
  { symbol: "dozen", key: "dozen" },
  { symbol: "thousand units", key: "thousandUnits" },
  { symbol: "kg", key: "kg" },
  { symbol: "g", key: "g" },
  { symbol: "t", key: "t" },
  { symbol: "lb", key: "lb" },
  { symbol: "l", key: "l" },
  { symbol: "ml", key: "ml" },
  { symbol: "m3", key: "m3" },
  { symbol: "gal", key: "gal" },
  { symbol: "m", key: "m" },
  { symbol: "km", key: "km" },
  { symbol: "ft", key: "ft" },
  { symbol: "m2", key: "m2" },
  { symbol: "ft2", key: "ft2" },
  { symbol: "container", key: "container" },
  { symbol: "pallet", key: "pallet" },
  { symbol: "box", key: "box" },
  { symbol: "bottle", key: "bottle" },
  { symbol: "bag", key: "bag" },
] as const;
